import { render, staticRenderFns } from "./SSN.vue?vue&type=template&id=7a08c87f&scoped=true"
import script from "./SSN.vue?vue&type=script&lang=js"
export * from "./SSN.vue?vue&type=script&lang=js"
import style0 from "./SSN.vue?vue&type=style&index=0&id=7a08c87f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a08c87f",
  null
  
)

export default component.exports